// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
//
// Formatting and the two DIFFERENT escaping functions. `esc` is for text
// interpolated into innerHTML; `attr` additionally encodes newlines as &#10;
// because an innerHTML-built attribute needs the entity, while setAttribute
// takes a raw "\n". Using the wrong one renders a literal "&#10;" in tooltips.

export function esc(s: unknown): string {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** For attributes written into an innerHTML string (e.g. data-tip="…"). */
export function attr(s: unknown): string {
  return esc(s).replace(/\n/g, '&#10;');
}

export function num(n: number): string {
  return Math.round(n).toLocaleString('en-AU');
}

export function pct(n: number, dp = 1): string {
  return `${(n * 100).toFixed(dp)}%`;
}

export function km(n: number): string {
  if (n < 1) return `${Math.round(n * 1000)} m`;
  if (n < 10) return `${n.toFixed(1)} km`;
  return `${Math.round(n)} km`;
}

export function mhz(n: number): string {
  return n >= 1000 ? `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)} GHz` : `${n} MHz`;
}

export function signed(n: number): string {
  return `${n > 0 ? '+' : ''}${num(n)}`;
}

export function slug(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
